import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SmToast, SmToastClickLinkEvent } from './sm-toast.component';
import { slideOut } from '@Shared/Animations/slide-out.animation';
import { slideUp } from '@Shared/Animations/slide-up.animation';
import { triggerChildAnimation } from '@Shared/Animations/trigger-child.animation';
import { verticalCollapseAnimation } from '@Shared/Animations/vertical-collapse.animation';

@Component({
    standalone: false,
    selector: 'sm-toasts',
    templateUrl: './sm-toasts.component.html',
    styleUrls: ['./sm-toasts.component.scss'],
    animations: [verticalCollapseAnimation, triggerChildAnimation, slideUp, slideOut]
})

export class SmToastsComponent {
    @Input() toasts: SmToast[] = [];

    @Output() onClickLink: EventEmitter<SmToastClickLinkEvent> = new EventEmitter();
    
    dismiss(e: Event) {
        const target = e.target as HTMLElement;
        if (target) {
            const toastEl = target.closest('.sm-toast');
            if (toastEl) {
                toastEl.classList.add('fadeout');
                Promise.all(toastEl.getAnimations().map((animation) => animation.finished)).then(
                    () => toastEl.remove()
                );
            }
        }
    }
}